<footer class="sticky-footer bg-white">
    <div class="container my-auto">
      <div class="copyright text-center my-auto">
        <span>Copyright &copy; 2024 MMITA. All Rights Reserved</span>
      </div>
    </div>
</footer>
